import { createContext } from 'react';

export const PageHeaderBandContext = createContext(false);
